__turbopack_context__.v({
  "notification": "notifications-module-scss-module__quS86G__notification",
  "notification-error": "notifications-module-scss-module__quS86G__notification-error",
  "notification-info": "notifications-module-scss-module__quS86G__notification-info",
  "notification-success": "notifications-module-scss-module__quS86G__notification-success",
  "notification-warning": "notifications-module-scss-module__quS86G__notification-warning",
  "notificationContainer": "notifications-module-scss-module__quS86G__notificationContainer",
  "notificationEnter": "notifications-module-scss-module__quS86G__notificationEnter",
  "notificationEnterActive": "notifications-module-scss-module__quS86G__notificationEnterActive",
  "notificationLeave": "notifications-module-scss-module__quS86G__notificationLeave",
  "notificationLeaveActive": "notifications-module-scss-module__quS86G__notificationLeaveActive",
  "title": "notifications-module-scss-module__quS86G__title",
});
